// extracted by mini-css-extract-plugin
export var button = "_1c-1";
export var featuredLink = "_1c-4";
export var spinner = "_1c-2";
export var spinnerContainer = "_1c-3";
export var text = "_1c-0";